var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-detail-section mg20"},[_c('h3',[_vm._v("第三方合作参数")]),_vm._v(" "),_c('div',[_c('el-row',{staticClass:"order-pad20"},[_c('p',[_vm._v("AppID："+_vm._s(_vm.AppID))]),_vm._v(" "),_c('p',[_vm._v("AppSecret："+_vm._s(_vm.AppSecret))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-997658da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/partial/order_corp.vue
// module id = 2361
// module chunks = 0